module.exports = __webpack_public_path__ + "static/cuartafecha-d7d6a180385acc8780a5983b4f7ea90e.jpg";